module.exports = __webpack_public_path__ + "img/JobOpportunities.6782c16b.svg";